import { render, staticRenderFns } from "./iptv.vue?vue&type=template&id=15d5b78a"
import script from "./iptv.vue?vue&type=script&lang=js"
export * from "./iptv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports